export const CtrLTemplate = (collection, property) => {

    let Schedtags = [], Normtags = [];

    for (let i = 0; i < collection.length; i++) {

        (collection[i].isSchedule === 1) ?
            Schedtags.push(collection[i])
            :
            Normtags.push(collection[i])
    }

    // Group the tags by property
    var i = 0, val, index, 
        values = [], result = [], displays = [];
    for (; i < Schedtags.length; i++) {
        val = Schedtags[i][property]; // subgroup으로 구분? 
        index = values.indexOf(val);
        if (index > -1) {
            result[index].push(Schedtags[i]);
        } else {
            values.push(val);
            result.push([Schedtags[i]]);
            displays.push([Schedtags[i][property]]);
        }
    }
    return [Normtags, result, displays];
}

export const groupArrayOfObjects = (list, key) => {
    return list.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export const GroupTemplate = (collection, property) => { // * Analog : (GenTags, tag_display_subgroup === hmi_display_subgroup)

    // Group the tags by property
    var i = 0, val,  index,
        values = [], result = [];
    for (; i < collection.length; i++) {
        val = collection[i][property];
        index = values.indexOf(val);
        if (index > -1) {
            result[index].push(collection[i]);
        } else {
            values.push(val);
            result.push([collection[i]]);
        }
    }
    return [result];
}

export const ChunkTemplate = (collection, property) => {

    // Group the tags by property
    var i = 0, val,  index,
        values = [], result = [];
    for (; i < Object.keys(collection).length; i++) {
        val = Object.keys(collection)[i][property];
        index = values.indexOf(val);
        if (index > -1) {
            result[index].push(Object.keys(collection)[i]);
        } else {
            values.push(val);
            result.push([Object.keys(collection)[i]]);
        }
    }
    return [result];
}

